import { z } from "zod";
export const AuthV2Request = z.object({
    state: z.string(),
    codeChallenge: z.string(),
    codeChallengeMethod: z.string(),
    redirectUri: z.string(),
    sessionId: z.string(),
    code: z.string().optional(),
    codeVerifier: z.string().optional(),
    selectScope: z.boolean().optional(),
    clientId: z.string().optional(),
});
